import { render } from "./WCProductPricing.vue?vue&type=template&id=6229688f&scoped=true"
import script from "./WCProductPricing.vue?vue&type=script&lang=js"
export * from "./WCProductPricing.vue?vue&type=script&lang=js"

import "./WCProductPricing.vue?vue&type=style&index=0&id=6229688f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6229688f"]])

export default __exports__